export const RESOLUTION_NAMES = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
};

const RESOLUTION_HEIGHT = {
  [RESOLUTION_NAMES.LOW]: 480,
  [RESOLUTION_NAMES.MEDIUM]: 720,
};

export default class Resolution {
  _name = null;
  constructor(resolutionName) {
    if (!Object.values(RESOLUTION_NAMES).includes(resolutionName)) {
      throw new Error(
        `${Resolution.name} was not initialized with correct params`,
      );
    }
    this._name = resolutionName;
  }
  // We constraint the height as a control on resolution
  getScaledHeight = (originalWidth, originalHeight) =>
    RESOLUTION_HEIGHT[this._name];

  getScaledWidth = (originalWidth, originalHeight) => {
    let newWidth =
      originalWidth * (RESOLUTION_HEIGHT[this._name] / originalHeight);
    if (newWidth % 2 !== 0) {
      // If width is not divisible by 2 - aligns with calculations in VIS
      newWidth = Math.floor(newWidth + 1);
    }
    return newWidth;
  };

  get name() {
    return this._name;
  }
  static getLowResolution = () => {
    return new Resolution(RESOLUTION_NAMES.LOW);
  };

  static getMediumResolution = () => {
    return new Resolution(RESOLUTION_NAMES.MEDIUM);
  };

  static isResolution(resolution) {
    return resolution instanceof Resolution;
  }
}
